import script from "./TaskItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskItemList.vue?vue&type=script&setup=true&lang=js"

import "./TaskItemList.vue?vue&type=style&index=0&id=554dcd74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554dcd74"]])

export default __exports__